import React, { useEffect, useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import Header from '../component/Header';
import Spinner from '../component/Spinner';
import { getSummary } from '../api/auth';
import dayjs from 'dayjs';

function Menu() {

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [date, setDate] = useState('');
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!activeAccount) {
            navigate("/");
        }
    }, [activeAccount]);

    useEffect(() => {
        (async () => {
            await fetchData();
        })();
    }, [refresh]);

    useEffect(() => {
        // Set up an interval to fetch data every 30 seconds
        const intervalId = setInterval(() => {
            fetchData();
        }, 1000 * 30); // 30 seconds

        // Clean up the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, []);

    const fetchData = async () => {
        try {
            setIsShow(true);
            const result = await getSummary();
            console.log('result', result);
            if (result.ok === true) {
                result?.data?.forEach((row) => {
                    if (row.PLANT_CODE === "MI") {
                        row.PLANT_CODE = "MNA-MI";
                        row.DISPLAY_IDX = 0;
                    } else if (row.PLANT_CODE === "OH") {
                        row.PLANT_CODE = "MNA-OH";
                        row.DISPLAY_IDX = 1;
                    } else {
                        row.DISPLAY_IDX = 2;
                    }
                });
                result?.data?.sort((a, b) => a.DISPLAY_IDX - b.DISPLAY_IDX);
                setData(result.data);
                setDate(result.date);
            } else {
                alert("API CALL FAIL");
            }
        } catch (error) {
            console.log('error', error);
            alert(error.message);
        } finally {
            setIsShow(false);
        }
    }

    const moveTo = (path) => {
        navigate(path);
    }

    return (
        <>
            <Spinner isShow={isShow} />
            <Header setRefresh={setRefresh} />
            <div className='p-1 text-md bg-white dark:bg-black text-black dark:text-white'>
                <div className="flex flex-row justify-end">
                    <div className={`${((new Date().getTime() - new Date(date).getTime()) / (1000 * 60)) > 10 ? "bg-red-500" : ""}`}>
                        {dayjs(date).format('MMM, D YYYY(ddd) HH:mm A')}
                    </div>
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center text-gray-500 border border-collapse border-white">
                        <thead className="text-xs bg-white dark:bg-black text-black dark:text-white ">
                            <tr className="bg-gray-300 dark:bg-[#1D3FA3]">
                                <th scope="col" className="border py-1">
                                    PLANT
                                </th>
                                <th scope="col" className="border py-1">
                                    PLAN
                                </th>
                                <th scope="col" className="border py-1">
                                    RESULT
                                </th>
                                <th scope="col" className="border py-1">
                                    GAP
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-black text-black dark:text-white">
                            {data && data.map((v, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <tr className={`bg-white dark:bg-black text-black dark:text-white border-b`}>
                                            <td scope="row" className={`border py-1 font-medium bg-gray-300 dark:bg-[#1D3FA3]`}
                                                style={{ width: '25%' }}>
                                                {v.PLANT_CODE}
                                            </td>
                                            <td className="border py-1" style={{ width: '25%' }}>
                                                {v.TARGET}
                                            </td>
                                            <td className="border py-1" style={{ width: '25%' }}>
                                                {v.RESULT}
                                            </td>
                                            <td className="border py-1" style={{ width: '25%' }}>
                                                {v.GAP}
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                {/* MENU */}
                <div
                    className={`bg-white dark:bg-black text-black dark:text-white`}
                >
                    <div className="flex flex-row gap-2 p-2 mt-2">
                        <div className="w-24 font-bold text-lg border rounded-md flex justify-center items-center">
                            MNA-MI
                        </div>
                        <ul className="flex-1">
                            <li className="p-2 cursor-pointer border rounded-md" onClick={() => { moveTo("/mes/buildstatus/mi/front") }}>Build Status-Front</li>
                            <li className="p-2 cursor-pointer border rounded-md mt-1" onClick={() => { moveTo("/mes/buildstatus/mi/rear") }}>Build Status-Rear</li>
                            <li className="p-2 cursor-pointer border rounded-md mt-1" onClick={() => { moveTo("/mes/production/mi") }}>Production Summary</li>
                        </ul>
                    </div>
                    <div className="flex flex-row gap-2 p-2 mt-1">
                        <div className="w-24 font-bold text-lg border rounded-md flex justify-center items-center">
                            MNA-OH
                        </div>
                        <ul className="flex-1">
                            <li className="p-2 cursor-pointer border rounded-md" onClick={() => { moveTo("/mes/buildstatus/oh") }}>Build Status</li>
                            <li className="p-2 cursor-pointer border rounded-md mt-1" onClick={() => { moveTo("/mes/production/oh") }}>Production Summary</li>
                        </ul>
                    </div>
                    <div className="flex flex-row gap-2 p-2 mt-1">
                        <div className="w-24 font-bold text-lg border rounded-md flex justify-center items-center">
                            MUSe
                        </div>
                        <ul className="flex-1">
                            <li className="p-2 cursor-pointer border rounded-md" onClick={() => { moveTo("/mes/buildstatus/muse") }}>Build Status</li>
                            <li className="p-2 cursor-pointer border rounded-md mt-1" onClick={() => { moveTo("/mes/production/muse") }}>Production Summary</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Menu;
